export default __webpack_public_path__ + "static/media/AndharBahar1103.94506b16.png";